// extracted by mini-css-extract-plugin
export default {"wrap":"oVYxlHKa7qCRzw2KqvML"};